import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Appwrite from '@/assets/appwrite'
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/de'
import VueDateFns from 'vue-date-fns'
import TimeAgo from 'javascript-time-ago'
import TimeAgoDe from 'javascript-time-ago/locale/de'

Vue.use(VueDateFns)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

Vue.prototype.$appwrite = Appwrite

TimeAgo.addDefaultLocale(TimeAgoDe)
Vue.prototype.$timeAgo = new TimeAgo('de-DE')

new Vue({
    router,
    store,
    beforeCreate () {
        this.$store.dispatch('init')
    },
    render: h => h(App),
}).$mount('#app')
